import Update from '../components/update/Update';

function UpdatePage() {
  return <Update />;
}

export default UpdatePage;
